import { type MutationError, trpc } from '@/shared/api';

interface UseReorderCategoriesOptions {
  readonly onSuccess?: () => void;
}

/** 형제 전체 순서 재배치 — 노출 순서는 고객 화면 카테고리 순서와 연동된다. */
export const useReorderCategories = ({ onSuccess }: UseReorderCategoriesOptions = {}) => {
  const mutation = trpc.productManagement.categories.reorder.useMutation({ onSuccess });

  const error: MutationError | null = mutation.error;

  return {
    reorderCategories: mutation.mutate,
    isPending: mutation.isPending,
    error,
    /** 지난 오류를 지운다 — 같은 오류 줄을 쓰는 다른 요청을 시작할 때 옛 오류가 남지 않게. */
    reset: mutation.reset,
  };
};
